import { useEffect, useState } from "react";
import RequestCard from "./RequestCard";
import InfiniteScroll from "react-infinite-scroll-component";
import { useReenvioSolicitacao } from "~pages/Wallet/hooks/useWallet";
import { useNavigate } from "react-router-dom";
import { initialPath } from "~misc/paths";
import Loader from "~components/Form/components/Loader";
import { IconTop } from "~misc/icons";
import '~/components/SearchList/styles.scss';

const RequestList = ({ list, ReenviarSolicitacao, NovaSolicitacao, filters, total, skip, take, setSkip }) => {
  const [renderedItems, setRenderedItems] = useState(take);
  const [isLoading, setIsLoading] = useState(false);
  const loadMoreItems = () => {
    setIsLoading(true);
    setTimeout(() => {
      setRenderedItems((prevRenderedItems) => prevRenderedItems + 10);
      setSkip(skip + take);
      setIsLoading(false);
    }, 1100);
  };

  useEffect(() => {
    setRenderedItems(take);
  }, [filters]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
    <InfiniteScroll
      dataLength={renderedItems}
      next={loadMoreItems}
      hasMore={!!list && total !== undefined && renderedItems < total}
      loader={isLoading && <Loader />}
    >
      {list &&
        list.length > 0 &&
              list.slice(0, renderedItems).map((item) => (
          <RequestCard key={item.id} data={item} ReenviarSolicitacao={ReenviarSolicitacao} NovaSolicitacao={NovaSolicitacao} />
        ))}

        { !isLoading && list && renderedItems >= total && (
      <>

          <div className="text-center mt-8 mb-8 text-xl font-bold ">
            Fim da Listagem
          </div>
          <button className="voltar-ao-topo" onClick={() => scrollToTop()}>
            <IconTop />

          </button>
      </>
        )}

      </InfiniteScroll>
    </>
  );
};

export default RequestList;
